// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"672c4dd0","312":"538bd92e","453":"3847547b","602":"21f51542","627":"be08601f","692":"3ec50396","714":"fb577643","905":"444ffa03","923":"f65ea08e"}[chunkId] + ".chunk.js";
};